// src/Component/hooks/useDeleteJenis_beban.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * useDeleteJenisBeban adalah custom hook yang digunakan untuk menghapus data jenis beban dari backend.
 * @returns { Object } - Mengembalikan fungsi deleteJenisBeban, serta status loading dan error.
 */
const useDeleteJenisBeban = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk menghapus data jenis beban di backend.
   * @param { number } id - ID jenis beban yang akan dihapus.
   * @returns { Promise<boolean> } - Mengembalikan true jika berhasil, false jika gagal.
   */
  const deleteJenisBeban = async (id) => {
    setLoading(true);
    setError(null);

    try {
      if (!endpoints.jenis_beban || typeof endpoints.jenis_beban.delete !== 'function') {
        throw new Error('endpoints.jenis_beban.delete is not defined');
      }

      const response = await api.delete(endpoints.jenis_beban.delete(id), {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200 || response.status === 204) {
        return true;
      } else {
        setError('Gagal menghapus data jenis beban.');
        return false;
      }
    } catch (err) {
      console.error('Error deleting jenis beban:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat menghapus data jenis beban.'
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteJenisBeban, loading, error };
};

export default useDeleteJenisBeban;
